import { render, staticRenderFns } from "./hcd-frame.vue?vue&type=template&id=729b2114&scoped=true"
import script from "./hcd-frame.vue?vue&type=script&lang=js"
export * from "./hcd-frame.vue?vue&type=script&lang=js"
import style0 from "./hcd-frame.vue?vue&type=style&index=0&id=729b2114&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729b2114",
  null
  
)

export default component.exports